document.addEventListener("DOMContentLoaded", function () {
  const updateProgressBar = function () {
    const wrapper = document.querySelector('.drawer__cart-wrapper');
    const progressBarWrapper = wrapper?.querySelector('.cart-shipping__wrapper');

    if (!progressBarWrapper) {
      console.log('Progress bar wrapper not found.');
      return;
    }

    if (window.Shopify && window.Shopify.country) {
      const totalPrice = parseInt(document.querySelector("[data-total-price]")?.dataset?.totalPrice || "0", 10);
      const shopSymbol = "€";
      const progressPercentage = Math.min((totalPrice / 5900) * 100, 100); 

      const progressBar = document.querySelector(".progressbar_start");
      if (progressBar) {
        progressBar.style.width = `${progressPercentage}%`;
      }

      updateThreshold(5900, '.cart-shipping__success', '.progressbar_step1', '.free_shipping .checked-icon', totalPrice);
      updateRemainingAmount(totalPrice, shopSymbol);
    } else {
      console.error("Shopify country information is not available.");
    }
  };

  function updateThreshold(threshold, successSelector, progressBarSelector, checkedIconSelector, totalPrice) {
    const successElement = document.querySelector(successSelector);
    const progressBarStep = document.querySelector(progressBarSelector);
    const checkedIcon = document.querySelector(checkedIconSelector);

    if (totalPrice >= threshold) {
      successElement?.style.setProperty('display', 'block');
      checkedIcon?.style.setProperty('display', 'block');
      progressBarStep?.classList.add('custom-style');
    } else {
      successElement?.style.setProperty('display', 'none');
      checkedIcon?.style.setProperty('display', 'none');
      progressBarStep?.classList.remove('custom-style');
    }
  }

  function updateRemainingAmount(totalPrice, shopSymbol) {
    const remainingAmount = document.querySelector('.cart-shipping__numOuter');
    const remainingAmountText = document.querySelector('.cart-shipping__num');
    const remainingItemText = document.querySelector(".cart-shipping__numOuter--text");

    if (totalPrice < 5900) {
      const shipPrice = 5900 - totalPrice;
      remainingAmountText.textContent = `${shopSymbol}${(shipPrice / 100).toFixed(2)}`;
      remainingAmount.style.display = 'block';
      remainingItemText.textContent = "für kostenlosen Versand";
    } else {
      remainingAmount.style.display = 'none';
    }
  }

  updateProgressBar();

  document.addEventListener("cart-update", () => setTimeout(updateProgressBar, 150));
  document.addEventListener("add-to-cart-submit", () => setTimeout(updateProgressBar, 150));
});
